import { PageDocuments } from "@components/modules/documents/listing/PageDocuments";
import { NavigationDocuments } from "@components/widgets/AppSubNav";
import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout title={t`Documents`} navigation={<NavigationDocuments />}>
    <DemoModule module={Modules.Documents}>
      <PageDocuments />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/documents/")({
  component: Page,
});
